export class Did {
     
    private id: number; 
    private phone: string; 
    private status: string; 
    private createdAt: Date; 
    private modifiedAt: Date;

    constructor( id: number, phone: string, status: string, createdAt: Date, modifiedAt: Date,) {
        this.id = id;
        this.phone = phone;
        this.status = status;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        
    }

    
    public Id = (): number => {
        return this.id
    }
    public Phone = (): string => {
        return this.phone
    }
    public Status = (): string => {
        return this.status
    }
    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }
}